import { DataModel } from 'common/models/utility-models/base-model';

export class CompanyLocationModel extends DataModel {
  override id: string | number;
  companyName: any = '';
  locName: any = '';
  internRequired: any = '';
  locAddress: any = '';
}
